import React from 'react';
import { motion } from 'framer-motion';
const points = [{
  id: 1,
  title: 'Precisión Láser',
  desc: 'Intervenciones mínimamente invasivas. Olvídate del torno tradicional y el dolor asociado.',
  img: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800&q=80'
}, {
  id: 2,
  title: 'Escaneo Digital 3D',
  desc: 'Impresiones digitales exactas en segundos. Sin pastas incómodas ni esperas interminables.',
  img: 'https://cdn.magicpatterns.com/uploads/uVQgEP7taKvPWCTC39Eghx/Imagen_2.jpg'
}, {
  id: 3,
  title: 'Atmósfera Zen',
  desc: 'Un entorno diseñado para tu relajación total. La ansiedad dental es cosa del pasado.',
  img: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&q=80'
}];
export function PainPoints() {
  return <section className="py-24 bg-night-900 relative z-20" data-id="element-78">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-80">
          <h2 className="font-serif text-3xl md:text-5xl text-white mb-4" data-id="element-81">
            Tu Transformación <span className="text-gold" data-id="element-82">Sin Dolor</span>
          </h2>
          <p className="font-sans text-pearl/70 max-w-2xl mx-auto" data-id="element-83">
            Hemos redefinido la experiencia odontológica integrando tecnología
            de vanguardia para garantizar tu máximo confort.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-84">
          {points.map((point, index) => <motion.div key={point.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-night-800 rounded-lg overflow-hidden group" data-id="element-85">
              <div className="h-64 overflow-hidden relative" data-id="element-86">
                <div className="absolute inset-0 bg-night-900/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-87" />
                <img src={point.img} alt={point.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-88" />
              </div>
              <div className="p-8" data-id="element-89">
                <h3 className="font-serif text-xl text-gold mb-3" data-id="element-90">
                  {point.title}
                </h3>
                <p className="font-sans text-pearl/80 text-sm leading-relaxed" data-id="element-91">
                  {point.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}